module.exports = __webpack_public_path__ + "img/2025-03-12c_1.a6dd6b33.jpg";